import clsx from "clsx";

export interface SegmentedOption<T extends string> {
    value: T;
    label: string;
}

interface SegmentedControlProps<T extends string> {
    options: SegmentedOption<T>[];
    value: T;
    onChange: (value: T) => void;
    /** Dipakai sebagai `aria-label` — wajib karena kontrol ini tanpa teks. */
    label: string;
    className?: string;
}

/**
 * Switch ringan untuk memilih satu dari beberapa opsi (rentang dashboard,
 * mode tampilan, dsb). Sengaja generik supaya bisa dipakai menu lain tanpa
 * menulis ulang gaya aktif/nonaktif.
 */
export function SegmentedControl<T extends string>({
    options,
    value,
    onChange,
    label,
    className,
}: SegmentedControlProps<T>) {
    return (
        <div
            role="tablist"
            aria-label={label}
            className={clsx(
                "app-content-subtle inline-flex h-10 shrink-0 items-center gap-1 rounded-xl border app-shell-border px-1",
                className,
            )}
        >
            {options.map((option) => {
                const active = option.value === value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onChange(option.value)}
                        className={clsx(
                            "whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-semibold transition-all duration-200",
                            active
                                ? "bg-[var(--color-primary)] text-white shadow-sm"
                                : "app-shell-text-muted hover:app-content-subtle-hover hover:text-[var(--app-text-primary)]",
                        )}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
